import React from 'react';

const defaultStyle =
  'btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-indigo-500';

const transparentStyle =
  'underline bg-transparent border-none text-blue-500 hover:text-blue-700 focus:outline-none dark:text-blue-300 dark:hover:text-blue-500';

export default function Button({
  label,
  onClick,
  variant,
  width,
  isVisible,
  disabled,
}) {
  if (!isVisible) {
    return null;
  }

  return (
    <button
      disabled={disabled}
      style={{ width }}
      onClick={onClick}
      type="button"
      className={variant === 'transparent' ? transparentStyle : defaultStyle}
    >
      {label}
    </button>
  );
}
